// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownItem_root__cEWy5","label":"DropdownItem_label__33Rsn","content":"DropdownItem_content__1_xfk"};